/***
 * To create a range filter from the list of options use range-filter element
 * Usage:
 * - Place and type="range" input element inside range-filter element
 * - create a container with data-filter-option-list attribute
 * - render type="checkbox" inputs inside the container.
 *  ( you can made some changes in this code for this to work with text or number inputs )
 * - render css = component-range.css to look good
 *
 * Example:
 * <range-filter data-filter-option-list>
    <input
      type="range"
      id="{{ id }}"
      min="0"
      step="1"
      max="{{ max_value }}"
      value="{{ max_value }}"
      list="{{ values_id }}"
      data-values="{{- range_value -}}"
      no-trigger-submit
      class="mt-1 w-full"
    />

    <datalist id="{{ values_id }}" class="mt-2 flex justify-between">
      {%- for item in filter.values -%}
        {%- if forloop.first or forloop.last -%}
          <option value="{{- forloop.index -}}" label="{{- item.value -}}"></option>
        {%- endif -%}
      {%- endfor -%}
    </datalist>

    <ul
      class="hidden"
      data-filter-option-list
    >
      {%- for value in filter.values -%}
        <input type="checkbox"  name="{{- value.param_name -}}" value="{{- value.value -}}" />
      {%- endfor -%}
    </ul>
  </range-filter>
 *
 */

if (!customElements.get('range-filter')) {
  class RangeFilter extends HTMLElement {
    constructor() {
      super();

      this.rangeInput = this.querySelector('input[type="range"]');
      this.actualInputs = Array.from(this.querySelectorAll('[data-filter-option-list] input'));

      if (!this.rangeInput || !this.actualInputs) return;

      this.values = this.rangeInput.getAttribute('data-values').split(',') ?? [];
      this.listenRangeInput();
      this.initValue();
    }

    initValue() {
      const checkedInputs = this.actualInputs.filter((e) => e.checked);
      if (!checkedInputs.length) {
        this.resetValue();
        return;
      }

      const lastInput = checkedInputs[checkedInputs.length - 1];
      if (!lastInput) return;

      const index = this.values.indexOf(lastInput.value);

      if (~index) {
        this.rangeInput.value = index;
      }
    }

    resetValue() {
      this.rangeInput.value = this.rangeInput.max;
    }

    setValue(value) {
      const index = Number(value);

      const numberValue = this.values[index];

      this.actualInputs.forEach((input) => {
        input.checked = Number(input.value) <= Number(numberValue);
      });
    }

    listenRangeInput() {
      this.rangeInput.addEventListener('input', (ev) => {
        this.setValue(ev.target.value);
      });
    }
  }

  customElements.define('range-filter', RangeFilter);
}
